export default __webpack_public_path__ + "static/media/steakhache.9b9ee37c.png";